module.exports = __webpack_public_path__ + "static/media/X5-B.ff1c1198.png";